import React, { useEffect, useState } from 'react';
import { ContainerComponent, ParagraphComponent, SubtitleComponent } from '../../components';
import { resumePortalSSOIfNeeded } from '../../sso/portalSso';
import './ssoResume.style.scss';

// Flow: tesenergy.hr -> /sso/start -> auth.tesenergy.hr -> tesenergy.hr/sso-resume -> /sso/mint -> portal.tesenergy.hr/sso

export default function SsoResume() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    resumePortalSSOIfNeeded().catch(() => {
      if (!cancelled) {
        setErrorMessage('We could not complete sign-in. Please try again.');
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ContainerComponent>
      <div className="ssoResume">
        <SubtitleComponent large>Signing you in...</SubtitleComponent>
        {errorMessage ? <ParagraphComponent>{errorMessage}</ParagraphComponent> : null}
      </div>
    </ContainerComponent>
  );
}
